const initialState = {
  fetching: false,
  fetched: false,
  updating: false,
  updated: false,
  deleted: false,
  deleting: false,
  items: [],
  error: null,
  nbResult: 0,
  pageSize: 10,
  paginationPage: 1,
  filter: {
    fileName: "",
    category: { value: null, label: "allCategories" },
    type: { value: null, label: "all" },
    year: { value: null, label: "all" }
  },
  organization: null,
  temporaryFileLink: {
    fetching: false,
    fetched: false,
    link: "",
    error: null
  }
};

export const annexeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_ANNEXE_LIST": {
      return { ...initialState };
    }
    case "SET_ANNEXE_LIST": {
      return {
        ...state,
        items: action.items
      };
    }
    case "FETCH_ANNEXE_LIST_PENDING": {
      return { ...state, fetching: true, fetched: false };
    }
    case "FETCH_ANNEXE_LIST_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult,
        filter: { ...state.filter }
      };
    }
    case "FETCH_ANNEXE_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case "canceled":
          return state;
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }

      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }

    case "SET_ANNEXE_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_ANNEXE_LIST_PAGE_SIZE": {
      return {
        ...state,
        pageSize: action.pageSize,
        paginationPage: 1
      };
    }

    case "SET_BALANCE_SHEET_ORGANIZATION": {
      return { ...state, organization: action.organization };
    }
    case "SELECT_ANNEXE_LIST_CATEGORY": {
      return {
        ...state,
        filter: { ...state.filter, category: action.category },
        paginationPage: 1
      };
    }
    case "SELECT_ANNEXE_TYPE": {
      return {
        ...state,
        filter: { ...state.filter, type: action.element },
        paginationPage: 1
      };
    }
    case "SELECT_ANNEXE_LIST_FILENAME": {
      return {
        ...state,
        filter: { ...state.filter, fileName: action.fileName },
        paginationPage: 1
      };
    }
    case "SELECT_ANNEXE_LIST_YEAR": {
      return {
        ...state,
        filter: { ...state.filter, year: action.year },
        paginationPage: 1
      };
    }

    case "SET_ANNEXE_TMP_LINK": {
      return {
        ...state,
        temporaryFileLink: {
          ...state.temporaryFileLink,
          link: action.link
        }
      };
    }

    case "FETCH_ANNEXE_TMP_LINK_PENDING": {
      return {
        ...state,
        temporaryFileLink: {
          ...state.temporaryFileLink,
          fetching: true,
          fetched: false
        }
      };
    }
    case "FETCH_ANNEXE_TMP_LINK_FULFILLED": {
      const { data } = action.payload.data;

      return {
        ...state,
        temporaryFileLink: {
          fetching: false,
          fetched: true,
          link: data,
          error: null
        }
      };
    }
    case "FETCH_ANNEXE_TMP_LINK_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case "canceled":
          return state;
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }

      return {
        ...state,
        temporaryFileLink: {
          ...state.temporaryFileLink,
          fetching: false,
          link: "",
          error
        }
      };
    }

    case `DELETE_ANNEXE_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_ANNEXE_FULFILLED`: {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case `DELETE_ANNEXE_REJECTED`: {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }

    case `SET_MAIN_ANNEXE_PENDING`: {
      return { ...state, updated: false, updating: true };
    }
    case `SET_MAIN_ANNEXE_FULFILLED`: {
      return {
        ...state,
        updating: false,
        updated: true
      };
    }
    case `SET_MAIN_ANNEXE_REJECTED`: {
      return {
        ...state,
        updating: false,
        updated: false
      };
    }

    case `TOGGLE_CERTIFIED_ANNEXE_PENDING`:
    case `TOGGLE_HIDDEN_ANNEXE_PENDING`: {
      return { ...state, updated: false, updating: true };
    }
    case `TOGGLE_CERTIFIED_ANNEXE_FULFILLED`:
    case `TOGGLE_HIDDEN_ANNEXE_FULFILLED`: {
      return {
        ...state,
        updating: false,
        updated: true
      };
    }
    case `TOGGLE_CERTIFIED_ANNEXE_REJECTED`:
    case `TOGGLE_HIDDEN_ANNEXE_REJECTED`: {
      return {
        ...state,
        updating: false,
        updated: false
      };
    }

    default:
      return state;
  }
};

const initialAnnexeCategorySuggestionsState = {
  fetching: false,
  fetched: false,
  items: [],
  enabled: [],
  error: null
};
export const annexeCategorySuggestionsReducer = (
  state = initialAnnexeCategorySuggestionsState,
  action
) => {
  switch (action.type) {
    case "INIT_ANNEXE_CATEGORY_SUGGESTIONS": {
      return initialAnnexeCategorySuggestionsState;
    }
    case "SET_ANNEXE_CATEGORY_SUGGESTIONS": {
      return {
        ...state,
        items: action.items
      };
    }
    case "FETCH_ANNEXE_CATEGORY_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ANNEXE_CATEGORY_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_ANNEXE_CATEGORY_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case "SET_ENABLED_ANNEXE_CATEGORIES": {
      return {
        ...state,
        items: action.items
      };
    }
    case "FETCH_ENABLED_ANNEXE_CATEGORIES_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ENABLED_ANNEXE_CATEGORIES_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        enabled: action.payload.data.data
      };
    }
    case "FETCH_ENABLED_ANNEXE_CATEGORIES_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    default:
      return state;
  }
};

const initialBalanceSheetAttachmentsState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null
};
export const balanceSheetAttachmentsReducer = (
  state = initialBalanceSheetAttachmentsState,
  action
) => {
  switch (action.type) {
    case "INIT_BALANCE_SHEET_ATTACHMENTS": {
      return initialBalanceSheetAttachmentsState;
    }
    case "SET_BALANCE_SHEET_ATTACHMENTS": {
      return {
        ...state,
        items: action.items
      };
    }
    case "FETCH_BALANCE_SHEET_ATTACHMENTS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_BALANCE_SHEET_ATTACHMENTS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_BALANCE_SHEET_ATTACHMENTS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/annexe.js